var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.75,
    height: 50,
    viewBox: "0 0 168.75 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2863"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2860"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2859"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.5 1a5.282 5.282 0 015.25 5.25v37.5A5.282 5.282 0 01162.5 49H6.25A5.282 5.282 0 011 43.75V6.25A5.282 5.282 0 016.25 1H162.5m0-1H6.25A6.189 6.189 0 000 6.25v37.5A6.189 6.189 0 006.25 50H162.5a6.189 6.189 0 006.25-6.25V6.25A6.189 6.189 0 00162.5 0z",
    "data-name": "Path 216",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2861",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.25 12.75a3.4 3.4 0 01-.875 2.5 3.875 3.875 0 01-6.625-2.75 3.841 3.841 0 013.875-3.875 3.328 3.328 0 011.5.375 2.722 2.722 0 011.125.875l-.625.625a2.331 2.331 0 00-2-.875 2.487 2.487 0 00-2 .875 2.575 2.575 0 00-.875 2.125 2.575 2.575 0 00.875 2.125 3.219 3.219 0 002 .875 2.742 2.742 0 002.125-.875 2.07 2.07 0 00.625-1.5h-2.75v-1h3.625v.5z",
    "data-name": "Path 217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 9.625h-3.375V12h3.125v.875h-3.125v2.375H65v1h-4.375v-7.5H65z",
    "data-name": "Path 218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.125 16.25h-1V9.625H66V8.75h5.25v.875h-2.125z",
    "data-name": "Path 219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.875 16.25v-7.5h1v7.5z",
    "data-name": "Path 220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.125 16.25h-1V9.625H77V8.75h5.125v.875H80v6.625z",
    "data-name": "Path 221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 15.25a3.875 3.875 0 01-6.625-2.75 3.875 3.875 0 117.75 0A3.675 3.675 0 0192 15.25zm-4.75-.625a2.95 2.95 0 002 .875 2.487 2.487 0 002-.875 3.016 3.016 0 00.875-2.125 2.575 2.575 0 00-.875-2.125 2.95 2.95 0 00-2-.875 2.487 2.487 0 00-2 .875 3.016 3.016 0 00-.875 2.125 2.575 2.575 0 00.875 2.125z",
    "data-name": "Path 222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 16.25v-7.5h1.125l3.625 5.875V8.75h1v7.5h-1l-3.875-6.125v6.125z",
    "data-name": "Path 223"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.125 27.25a5.259 5.259 0 00-5.375 5.375A5.335 5.335 0 0085.125 38a5.259 5.259 0 005.375-5.375 5.186 5.186 0 00-5.375-5.375zm0 8.5a3.1 3.1 0 01-3-3.25 3.1 3.1 0 013-3.25 3.028 3.028 0 013 3.25 3.1 3.1 0 01-3 3.25zM73.5 27.25a5.259 5.259 0 00-5.375 5.375A5.335 5.335 0 0073.5 38a5.259 5.259 0 005.375-5.375A5.186 5.186 0 0073.5 27.25zm0 8.5a3.1 3.1 0 01-3-3.25 3.1 3.1 0 013-3.25 3.028 3.028 0 013 3.25 3.1 3.1 0 01-3 3.25zm-13.875-6.875v2.25H65A4.727 4.727 0 0163.75 34a5.533 5.533 0 01-4.125 1.625 5.82 5.82 0 01-5.875-6 5.9 5.9 0 015.875-6 6.2 6.2 0 014.125 1.625l1.625-1.625a8.01 8.01 0 00-5.625-2.25 8.432 8.432 0 00-8.375 8.25 8.432 8.432 0 008.375 8.25A7.194 7.194 0 0065.5 35.5a7.525 7.525 0 002-5.25 4.687 4.687 0 00-.125-1.375zm56.75 1.75a4.857 4.857 0 00-4.5-3.375 5.034 5.034 0 00-5 5.375 5.231 5.231 0 005.25 5.375 5.128 5.128 0 004.375-2.375l-1.75-1.25a3.047 3.047 0 01-2.625 1.5 2.712 2.712 0 01-2.625-1.625l7.125-3zm-7.25 1.75a3.037 3.037 0 012.75-3.125 2.211 2.211 0 012 1.125zM103.25 37.5h2.375V21.875h-2.375zm-3.75-9.125a4.116 4.116 0 00-2.875-1.25A5.371 5.371 0 0091.5 32.5a5.176 5.176 0 005.125 5.25 3.589 3.589 0 002.75-1.25h.125v.75c0 2-1.125 3.125-2.875 3.125A2.777 2.777 0 0194 38.5l-2 .875a5.157 5.157 0 004.75 3.125c2.75 0 5-1.625 5-5.5v-9.5H99.5v.875zm-2.75 7.375a3.1 3.1 0 01-3-3.25 3.1 3.1 0 013-3.25 3.007 3.007 0 012.875 3.25 3.007 3.007 0 01-2.875 3.25zm30.5-13.875h-5.625V37.5H124v-5.875h3.25a4.881 4.881 0 100-9.75zm.125 7.5H124V24h3.375a2.746 2.746 0 012.75 2.625 2.861 2.861 0 01-2.75 2.75zm14.375-2.25a4.2 4.2 0 00-4.125 2.375l2.125.875a2.208 2.208 0 012.125-1.125 2.349 2.349 0 012.5 2v.125A4.958 4.958 0 00142 30.75c-2.25 0-4.5 1.25-4.5 3.5a3.662 3.662 0 003.875 3.5 3.518 3.518 0 003-1.5h.125v1.25h2.25v-6a4.731 4.731 0 00-5-4.375zm-.25 8.625c-.75 0-1.875-.375-1.875-1.375 0-1.25 1.375-1.625 2.5-1.625a4.834 4.834 0 012.125.5 2.911 2.911 0 01-2.75 2.5zm13.125-8.25L152 34.25h-.125l-2.75-6.75h-2.5l4.125 9.5-2.375 5.25h2.375l6.375-14.75zm-21 10H136V21.875h-2.375z",
    "data-name": "Path 224",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2862",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.875a3.858 3.858 0 00-.25 1.375v27.5a3.7 3.7 0 00.25 1.25l15-15.125z",
    "data-name": "Path 225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.625 24.125l4.75-4.75-17.625-10a2.378 2.378 0 00-2-.25z",
    "data-name": "Path 226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.625 25.875l-14.875 15a2.378 2.378 0 002-.25l17.625-10z",
    "data-name": "Path 227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 23.25L34.375 20l-5 5 5 5L40 26.875c1.75-1.125 1.75-2.625 0-3.625z",
    "data-name": "Path 228"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.178e1127.svg";
export { ForwardRef as ReactComponent };